import { AutoMenu } from "../../auto-menu";
import { Box } from "../../box";
import type { IProps } from "./auto-table-menu.types";

/**
 * An {@link AutoMenu} intended for use inside an AutoTable row (e.g. a row actions menu).
 *
 * Mantine renders the menu dropdown in a portal, but React still bubbles synthetic events through
 * the React tree to the row's `onClick`, which would fire `onRowClick` or toggle row expansion.
 * This wraps the menu in a `Box` that stops click propagation, so interacting with the menu —
 * opening it or clicking any item — never reaches the row.
 *
 * Accepts the same props as {@link AutoMenu}, plus an optional `wrapperProps` for styling the
 * wrapping `Box`.
 */
const AutoTableMenu = ({ wrapperProps, ...autoMenuProps }: IProps) => {
    const { onClick: wrapperOnClick, ...restWrapperProps } = wrapperProps ?? {};

    return (
        <Box
            {...restWrapperProps}
            onClick={(event) => {
                event.stopPropagation();
                wrapperOnClick?.(event);
            }}
        >
            <AutoMenu {...autoMenuProps} />
        </Box>
    );
};

export { AutoTableMenu };
